module.exports = __webpack_public_path__ + "img/sun.6515e7c6.svg";